import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { isEqual, isEqualWith } from 'lodash';

import './FundkyDragDrop.less';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

class FundkyDragDrop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: props.children
    };
  }

  componentDidUpdate(prevProps) {
    // IMPORTANT: Use key for each children. Use ID as key.
    if (!isEqualWith(prevProps.children, this.props.children, (a, b) => isEqual(a.key, b.key)))
      this.setState({ items: this.props.children });
  }

  onDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items });
    this.props.onChange(items);
  }

  render() {
    return (
      <>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable" direction={this.props.direction}>
            {provided => (
              <div
                className="Draggable_Wrap"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {this.state.items.map((item, index) => (
                  <Draggable
                    key={item.props.id}
                    draggableId={item.props.id}
                    index={index}
                    isDragDisabled={this.props.isDragDisabled}
                  >
                    {provided => (
                      <div
                        className="Draggable_Item"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        {item}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </>
    );
  }
}

FundkyDragDrop.propTypes = {
  direction: PropTypes.oneOf(['vertical', 'horizontal']),
  isDragDisabled: PropTypes.bool,
  onChange: PropTypes.func
};

FundkyDragDrop.defaultProps = {
  direction: 'vertical',
  isDragDisabled: false,
  onChange: () => {}
};

export default FundkyDragDrop;
